// import { DetailSupportFormTestContainer } from "../../../containers/SupportSystem/SupportForm/DetailSupportFormTestContainer";
import { EstimateAnnounce11FormContainer } from "../../../containers/SupportSystem/SupportForm/EstimateAnnounce11FormContainer";
export function EstimateAnnounce11FormPage() {
    return (
        <EstimateAnnounce11FormContainer />
    );
}